import { Star } from "lucide-react";

import { Badge } from "../ui/badge";
import { cn } from "../ui/utils";

export function TokenBadge({ tokens = 0, label = "stars", className }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        "inline-flex items-center gap-2 rounded-full border-border px-3 py-1.5 text-sm font-medium text-foreground/80",
        className
      )}
    >
      <Star className="h-4 w-4 text-primary" />
      <span>{tokens}</span>
      <span className="capitalize text-muted-foreground">{label}</span>
    </Badge>
  );
}

